import { httpClient } from '@texas/api/httpClient/httpClient';

export interface Country {
  name: string;
  code: string;
  id: number;
  branchId: number;
  archived: boolean;
}

export interface CountryRequest {
  name: string;
  code: string;
  archived: boolean;
}

export const countriesApi = {
  getCountries: (branchId: number) =>
    httpClient.get<Country[]>(`metadata/countries/branch/${branchId}`),
  create: (branchId: number, request: CountryRequest) =>
    httpClient.post<Country>(`metadata/countries/branch/${branchId}`, {
      data: request,
    }),
  update: (id: number, request: CountryRequest) =>
    httpClient.put<Country>(`metadata/countries/${id}`, { data: request }),
};
